import "./NavBar.css";

import React from "react";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";

import { NavBarButton } from "../NavBarButton/NavBarButton";
import logo from "../../shared/imageAssets/logo.png";
import logoBlack from "../../shared/imageAssets/logo-black.png";

const homeDropdownContent = [{ text: "New Football Boots", url: "/" }];
const aboutUsDropdownContent = [{ text: "За Нас", url: "/about-us" }];
const productsDropdownContent = [
  { text: "Продукти", url: "/shop" },
  { text: "Количка", url: "/cart" },
  { text: "Поръчка", url: "/checkout" },
];
const blogDropdownContent = [
  { text: "Blog One Column", url: "/" },
  { text: "Blog Two Column", url: "/" },
  { text: "Blog Three Column", url: "/" },
];
const galleryDropdownContent = [{ text: "Галерия", url: "/gallery" }];
const contactsDropdownContent = [];
const pagesDropdownContent = [
  {
    firstUlLi: { text: "Typography", url: "#" },
    secondUl: [
      { text: "Headers", url: "#" },
      { text: "Text", url: "#" },
      { text: "Text Columns", url: "#" },
      { text: "Table", url: "#" },
      { text: "Separators", url: "#" },
    ],
  },
  {
    firstUlLi: { text: "Form Elements", url: "#" },
    secondUl: [
      { text: "Buttons", url: "#" },
      { text: "Forms", url: "#" },
    ],
  },
  {
    firstUlLi: { text: "ShortCodes", url: "#" },
    secondUl: [
      { text: "Accordions", url: "#" },
      { text: "Alerts", url: "#" },
      { text: "Tabs", url: "#" },
      { text: "ShortCodes", url: "#" },
    ],
  },
  {
    firstUlLi: { text: "Lists", url: "#" },
    secondUl: [
      { text: "Icons", url: "#" },
      { text: "Lists and Social Icons", url: "#" },
    ],
  },
];

export const NavBar = ({
  variation,
  mobileNavShowFunction,
  currentItemsCount,
  bakgrounColor,
  logoColor,
  navButtonsColor,
  navbarLogoFlexDirection,
  navbarLogoWidth,
  navbarAlignItems,
  navbarIconPMT,
  navbarLogoColor,
}) => {
  const [searchColor, setSearchColor] = useState("blue");
  const searchBar = useRef(null);
  const serachClick = () => {
    // searchBar.current.style.opacity = "1";
    searchBar.current.focus();
  };
  const asdasd = () => {
    console.log("submitted");
  };
  const handleMobileNavButton = () => {
    mobileNavShowFunction(100);
  };
  const handleMoveToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div
      style={{ backgroundColor: bakgrounColor }}
      className="navbar-container"
    >
      <Link
        style={{
          color: `${navButtonsColor}`,
          textDecoration: "none",
          flexDirection: `${navbarLogoFlexDirection}`,
          alignItems: `${navbarAlignItems}`,
          width: `${navbarLogoWidth}`,
        }}
        className="logo-link"
        to="/"
      >
        <img className="navbar-logo-icon" src={logo}></img>
        {navbarLogoFlexDirection === "column" ? (
          <p
            style={{ color: `${logoColor}`, marginTop: `${navbarIconPMT}` }}
            className="navbar-logo-p"
          >
            New Football Boots
          </p>
        ) : (
          <></>
        )}
      </Link>

      <div className="navbar-buttons-container">
        <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"Начало"}
          redirectUrl={"/"}
          isSingleUl={true}
          listContent={homeDropdownContent}
        />
        <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"За нас"}
          redirectUrl={"/about-us"}
          isSingleUl={true}
          listContent={aboutUsDropdownContent}
        />
        <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"Каталог"}
          redirectUrl={"/shop"}
          isSingleUl={true}
          listContent={productsDropdownContent}
        />
        {/* <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"Blog"} 
          redirectUrl={"/"}
          isSingleUl={true}
          listContent={blogDropdownContent}
        /> */}
        <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"Галерия"}
          redirectUrl={"/gallery"}
          isSingleUl={true}
          listContent={galleryDropdownContent}
        />
        <NavBarButton
          handleMoveToBottom={handleMoveToBottom}
          color={`${navButtonsColor}`}
          buttonText={"Контакти"}
          isNoUl={true}
          listContent={contactsDropdownContent}
        />
        {/* <NavBarButton
          color={`${navButtonsColor}`}
          buttonText={"Pages"}
          isMultyUl={true}
          listContent={pagesDropdownContent}
        /> */}
      </div>

      <Link className="shopping-cart-container" to={"/cart"}>
        <div className="shopping-items-count">{currentItemsCount}</div>
        <ShoppingCartIcon
          className="shopping-card-icon"
          sx={{
            transition: "all 0.4s",
            color: variation === "isCart" ? "#c0aa83" : `${navButtonsColor}`,
          }}
        />
      </Link>
      <div className="search-elements-container">
        {/* <SearchIcon
          onClick={serachClick}
          className="search-icon"
          sx={{ transition: "all 0.4s", color: `${navButtonsColor}` }}
        />
        <div ref={searchBar} className="searchInput">
          <input
            style={{ borderColor: searchColor }}
            placeholder="Search"
            type="text"
            onSubmit={asdasd}
          ></input>
          <MenuIcon />
        </div> */}
      </div>
      <div className="menu-icon-container">
        <MenuIcon
          onClick={handleMobileNavButton}
          sx={{
            fontSize: "45px",
            cursor: "pointer",
            color: `${navButtonsColor}`,
          }}
        />
      </div>
    </div>
  );
};
